export * from '@radix-ui/react-label';
